import { useEditor } from "@tiptap/react";

import CodeBlock from "@tiptap/extension-code-block";
import { Document } from "@tiptap/extension-document";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Strike from "@tiptap/extension-strike";

import { Core } from "@/view/TiptapArticleBody/extensions/core";
import { HardBreakBlock } from "@/view/TiptapArticleBody/extensions/HardBreakBlock";
import { HeadingBlock } from "@/view/TiptapArticleBody/extensions/HeadingBlock";
import IgnoreBlock from "@/view/TiptapArticleBody/extensions/IgnoreBlock";
import { Image } from "@/view/TiptapArticleBody/extensions/Image";
import {
  OrderedList,
  OrderedListItem,
  UnorderedList,
  UnorderedListItem,
} from "@/view/TiptapArticleBody/extensions/List";
import { ListenModeHighlightDecorator } from "@/view/TiptapArticleBody/extensions/ListenModeHighlightDecorator";
import { ParagraphBlock } from "@/view/TiptapArticleBody/extensions/ParagraphBlock";
import PreformattedBlock from "@/view/TiptapArticleBody/extensions/PreformattedBlock";
import QuoteBlock from "@/view/TiptapArticleBody/extensions/QuoteBlock";
import { INode } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

interface useMultipleChoiceEditorProps {
  content: INode | null;
  dataTestId: string;
  levelId?: string | string[] | undefined;
}

export const useMultipleChoiceEditor = ({
  content,
  dataTestId,
  levelId,
}: useMultipleChoiceEditorProps) => {
  return useEditor(
    {
      editorProps: {
        attributes: {
          class: "TipTapQuizQuestionChoice-text",
          "data-testid": dataTestId,
        },
      },
      extensions: [
        CodeBlock,
        Core,
        Document,
        HardBreakBlock,
        HeadingBlock.configure({ disableTranslation: true }),
        HorizontalRule,
        ListenModeHighlightDecorator,
        Image,
        IgnoreBlock,
        OrderedList.configure({ disableTranslation: true }),
        OrderedListItem,
        UnorderedList.configure({ disableTranslation: true }),
        UnorderedListItem,
        ParagraphBlock.configure({
          disableTranslation: true,
          useLegacyHighlighting: false,
        }),
        PreformattedBlock.configure({ disableTranslation: true }),
        QuoteBlock.configure({ disableTranslation: true }),
        Strike,
      ],
      content,
      editable: false,
    },
    [levelId, JSON.stringify(content)],
  );
};

export default useMultipleChoiceEditor;
